module.exports = __webpack_public_path__ + "img/logo-plan-recuperacion-transformacion-resilencia.8937c550.png";